// extracted by mini-css-extract-plugin
export default {"wrapper":"TransactionContainer_wrapper__NHeCo","wrapper_subtitle":"TransactionContainer_wrapper_subtitle__kjUqK","button":"TransactionContainer_button__+3u0T"};